import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Button } from "@mui/material";
import { IAppointment } from "../interface/iAppointment";
import React from "react";
import { AnalyticsContext } from "../context/analyticsContext";

const ExcelExportButton = (): React.JSX.Element => {
  const {
    getFilteredAppointmentList,
  }: {
    getFilteredAppointmentList: () => IAppointment[];
  } = React.useContext(AnalyticsContext);

  return (
    <Button
      size="small"
      fullWidth
      sx={{
        height: "100%",
      }}
      variant="contained"
      startIcon={<FileDownloadOutlinedIcon />}
      onClick={() => {
        // write a function for an excel export
        const exportData = getFilteredAppointmentList().map(
          (appointment: IAppointment) => ({
            date: appointment.date,
            status: appointment.status,
            startTime: appointment.startTime,
            endTime: appointment.endTime,
            lastName: appointment.lastName,
            firstName: appointment.firstName,
            phone: appointment.phone,
            email: appointment.email,
          })
        );
        const csvContent =
          "data:text/csv;charset=utf-8," +
          exportData.map((e) => Object.values(e).join(",")).join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");

        link.click();
        link.setAttribute("href", encodedUri);
        link.setAttribute(
          "download",
          `appointments_${new Date().toLocaleDateString()}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }}
    >
      Excel Export
    </Button>
  );
};

export default ExcelExportButton;
